export default params =>
  encodeURI(
    Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&')
  );
